<template>
  <div id="device-data">
    <dv-border-box-8 :dur="10" class="device-data-all">
      <div class="device-data-top">
        <dv-decoration-7>&nbsp; {{$t('RTData')}} &nbsp;</dv-decoration-7>
      </div>
      <div class="device-data-main" ref="scrollContainer" @mouseenter="pauseScroll"  @mouseleave="resumeScroll">
        <div v-for="(row,index) in sliceList(realDataList, 4)" :key="index" class="device-main-table">
          <div class="device-main-col">
            <div class="device-main-row"  v-for="(item,i) in row">
              <dv-border-box-12>
                <div class="device-main-tb" @click="getSelectParam(item.name)">
                  <div class="device-main-single">
                    <span class="device-main-time">{{item.ts}}</span>
                  </div>
                  <div class="device-main-single"> <!--默认  #FFD700  高于阈值red  低于阈值 #B388FF-->
<!--                    <span span style="display: table-cell; vertical-align: middle; color: #ff0000; text-shadow: 0 0 5px #FFD700, 0 0 10px #FFD700, 0 0 20px #FFEE00, 0 0 30px #FFEE00;">{{item.name}}</span>-->
                    <span class="device-main-name">{{item.name}}</span>
                  </div>
                  <div class="device-main-single" > <!--默认  #00FFE0  高于阈值red  低于阈值 #B388FF-->
                    <span class="device-main-value" :style="{ color: item.color }">{{item.value}}</span>
                  </div>
                </div>
              </dv-border-box-12>

            </div>
          </div>
        </div>
      </div>
    </dv-border-box-8>
  </div>
</template>

<script>
  import moment from "moment"
  export default {
    name: 'DeviceData',
    props: ["thresholdInfo"],
    components: {},
    computed: {
      sliceList() {
        return function (data,count) {
          if(data != undefined) {
            let index = 0;
            let arrTemp = [];
            for(let i = 0; i < data.length; i++) {
              index = parseInt(i / count);
              if(arrTemp.length <= index) {
                arrTemp.push([])
              }
              arrTemp[index].push(data[i]);
            }
            return arrTemp;
          }
        }
      },
    },
    data() {
      return {
        realDataList:[],
        scrollInterval: null,
        scrollDirection: 1,
        deviceInfo: {},
        paramList: [],
        thresholdArray: this.thresholdInfo,
      }
    },

    watch: {
      thresholdInfo() {
        this.thresholdArray = this.thresholdInfo;
        this.updateRealDataColor();
      }
    },


    mounted() {
      this.$nextTick(() => {
        this.startAutoScroll();
      });
    },

    beforeDestroy() {
      this.clearAutoScroll();
    },

    methods: {
      getDeviceList(deviceId, response) {
        this.realDataList = [];
        this.paramList = [];
        if (response === 'false' || JSON.stringify(response) == "{}") {
          return;
        }
        this.deviceInfo = deviceId;
        let HIFlg = localStorage.getItem("HI") === "HI" ? true : false;
        let levelRefer = localStorage.getItem('levelRefer');//获取设置水位值
        let snowRefer = localStorage.getItem('snowRefer'); //获取设置雪深值
        let emptyHRefer = localStorage.getItem('emptyHRefer');//获取设置空高值
        let emptyHDRefer = localStorage.getItem('emptyHDRefer');//获取设置高程值
        let noiseRefer = localStorage.getItem('noiseRefer');//获取设置噪声值
        for (let obj in response) {
          for (let i = 0; i < response[obj].length; i++) {
            let arrJson = {};
            let paramJson = {};
            arrJson.name = this.$t(obj).split(',')[0];
            arrJson.nameEn = obj;
            arrJson.ts = this.dateFormat(response[obj][i].ts);
            if(obj == 'level' || obj == 'Rwater' || obj == 'waterlevel') {//水深
              let levelValue = Math.abs(parseFloat(levelRefer) + parseFloat(response[obj][i].value)).toFixed(4);
              arrJson.value = this.$t(obj).split(',')[1] === undefined ? levelValue : levelValue + this.$t(obj).split(',')[1];
            } else if(obj == 'snowHeight' || obj == 'snowheight' || obj == 'sHt') {//雪深
              let snowValue = Math.abs(parseFloat(snowRefer) + parseFloat(response[obj][i].value)).toFixed();
              arrJson.value = this.$t(obj).split(',')[1] === undefined ? snowValue : snowValue + this.$t(obj).split(',')[1];
            } else if(obj == 'emptyHD') {
              let emptyHDValue = Math.abs(parseFloat(emptyHDRefer) + parseFloat(response[obj][i].value)).toFixed(3);
              arrJson.value = this.$t(obj).split(',')[1] === undefined ? emptyHDValue : emptyHDValue + this.$t(obj).split(',')[1];
            } else if(obj == 'emptyH' && !(emptyHRefer.toString() == '0')) {
              arrJson.value = this.$t(obj).split(',')[1] === undefined ? response[obj][i].value : response[obj][i].value + this.$t(obj).split(',')[1];
              let level = (parseFloat(emptyHRefer) - parseFloat(response[obj][i].value)) < 0 ? 0 : parseFloat(emptyHRefer) - parseFloat(response[obj][i].value);
              let flowNum =  (level *2399.5).toFixed(4);
              this.realDataList.push({
                name: '瞬时流量,L/dm³',
                ts: this.dateFormat(response[obj][i].ts),
                value: flowNum,
                color: '#60E2FF'
              })
            } else if(obj == 'noise' || obj == 'noi' || obj == 'noise1' || obj == 'noise2') {
              let noiseValue = Math.abs(parseFloat(noiseRefer) + parseFloat(response[obj][i].value)).toFixed(1);
              arrJson.value = this.$t(obj).split(',')[1] === undefined ? noiseValue : noiseValue + this.$t(obj).split(',')[1];
            } else if(HIFlg == true && obj == 'ambientHumidity') {
              arrJson.value = this.$t(obj).split(',')[1] === undefined ? response[obj][i].value : response[obj][i].value + this.$t(obj).split(',')[1];
              if(response.hasOwnProperty('ambientTemperature')) {
                let T = response['ambientTemperature'][0].value;
                let RH = response['ambientHumidity'][0].value;
                let HI = this.calculateHeatIndex(T, RH).toFixed(3);
                this.realDataList.push({
                  name: '热量指数',
                  ts: this.dateFormat(response[obj][i].ts),
                  value: HI,
                  color: '#60E2FF'
                })
              }
            } else if(arrJson.name == '天气状况') {
              switch (parseInt(response[obj][i].value)) {
                case 0:
                  arrJson.value = '晴';
                  break;
                case 1:
                  arrJson.value = "冰";
                  break;
                case 2:
                  arrJson.value = "雨";
                  break;
                case 3:
                  arrJson.value = "积水";
                  break;
                case 4:
                  arrJson.value = "融化中";
                  break;
                case 5:
                  arrJson.value = "结冰中";
                  break;
                case 16:
                  arrJson.value = '大雨';
                  break;
                case 17:
                  arrJson.value = '中雨';
                  break;
                case 18:
                  arrJson.value = '小雨';
                  break;
                case 32:
                  arrJson.value = '大毛毛雨';
                  break;
                case 33:
                  arrJson.value = '中毛毛雨';
                  break;
                case 34:
                  arrJson.value = '小毛毛雨';
                  break;
                case 50:
                  arrJson.value = '大雪';
                  break;
                case 51:
                  arrJson.value = '中雪';
                  break;
                case 52:
                  arrJson.value = '小雪';
                  break;
                case 64:
                  arrJson.value = '烟';
                  break;
                case 80:
                  arrJson.value = '雾';
                  break;
                case 96:
                  arrJson.value = '冰雪或高空坠物';
                  break;
                case 153:
                  arrJson.value = '飞虫或异常遮挡';
                  break;
              }
            } else if(arrJson.name == '风向') {
              arrJson.value = this.$t(obj).split(',')[1] === undefined ? response[obj][i].value : response[obj][i].value + this.$t(obj).split(',')[1];
              let windName = '';
              if(response[obj][i].value < 22.5 || response[obj][i].value >= 337.5){
                windName = '北风';
              } else if(response[obj][i].value >= 22.5 && response[obj][i].value < 67.5){
                windName = '东北风';
              }else if(response[obj][i].value >= 67.5 && response[obj][i].value < 112.5) {
                windName = '东风';
              } else if(response[obj][i].value >= 112.5 && response[obj][i].value < 157.5){
                windName = '东南风'
              } else if(response[obj][i].value >= 157.5 && response[obj][i].value < 202.5){
                windName = '南风';
              }else if(response[obj][i].value >= 202.5 && response[obj][i].value < 247.5) {
                windName = '西南风';
              } else if(response[obj][i].value >= 247.5 && response[obj][i].value < 292.5) {
                windName = '西风';
              } else if(response[obj][i].value >= 292.5 && response[obj][i].value < 337.5 ){
                windName = '西北风';
              }
              this.realDataList.push({
                name: '风向',
                ts: this.dateFormat(response[obj][i].ts),
                value: windName,
                color: '#60E2FF'
              })
            } else {
              arrJson.value = this.$t(obj).split(',')[1] === undefined ? response[obj][i].value : response[obj][i].value + this.$t(obj).split(',')[1];
            }
            arrJson.color = '#60E2FF';
            this.realDataList.push(arrJson);

            //倒序排序
            this.realDataList.sort(function (a, b) {
              return b.ts < a.ts ? -1 : 1
            });

            paramJson.ch = this.$t(obj).split(',')[0];
            paramJson.en = obj;
            this.paramList.push(paramJson);
          }
        }

      },

      updateRealDataColor() {
        this.realDataList = this.realDataList.map(item => {
          const thresholdItem = this.thresholdArray.find(t => t.name === item.nameEn);
          let color = '#60E2FF';     // 默认值颜色
          if (thresholdItem) {
            if (thresholdItem.state === 'up') {
              color = '#FF0000';
            } else if (thresholdItem.state === 'low') {
              color = '#FDFF00';
            }
          }

          return {
            ...item,
            color
          };
        });
      },

      getSelectParam(title) {
        const selectKey = this.paramList.find(item => item.ch === title);
        if (selectKey) {
          this.$emit("callBackInfo", selectKey);
        }
      },

      startAutoScroll() {
        const el = this.$refs.scrollContainer;
        if (!el) return;

        this.scrollInterval = setInterval(() => {
          el.scrollTop += this.scrollDirection;

          // 如果到底，切换为向上滚
          if (el.scrollTop + el.clientHeight >= el.scrollHeight) {
            this.scrollDirection = -1;
          }

          // 如果到顶，切换为向下滚
          if (el.scrollTop <= 0) {
            this.scrollDirection = 1;
          }
        }, 30); // 滚动速度控制
      },

      pauseScroll() {
        this.clearAutoScroll();
      },
      resumeScroll() {
        this.startAutoScroll();
      },
      clearAutoScroll() {
        if (this.scrollInterval) {
          clearInterval(this.scrollInterval);
          this.scrollInterval = null;
        }
      },

      dateFormat(timestamp) {
        if (timestamp && timestamp != "") {
          let dateStr = moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
          return dateStr;
        }
        return "-";
      },

      calculateHeatIndex(T, RH) {
        // 系数定义
        const c1 = -42.379;
        const c2 = 2.04901523;
        const c3 = 10.14333127;
        const c4 = -0.22475541;
        const c5 = -0.00683783;
        const c6 = -0.05481717;
        const c7 = 0.00122874;
        const c8 = 0.00085282;
        const c9 = -0.00000199;

        // 热量指数计算
        let HI = c1 + (c2 * T) + (c3 * RH) + (c4 * T * RH) + (c5 * T * T) + (c6 * RH * RH) +
          (c7 * T * T * RH) + (c8 * T * RH * RH) + (c9 * T * T * RH * RH);

        return HI;
      },

      getRandomBrightColor() {
        // 生成亮色（RGB 各通道偏高）
        const hue = Math.floor(Math.random() * 360);     // 任意色相
        return `hsl(${hue}, 100%, 88%)`;
      }
    }
  }
</script>

<style scoped lang="less">
  @import "less/DeviceData.less";
</style>



// WEBPACK FOOTER //
// src/components/DeviceData.vue